import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=70d7e6f2&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d7e6f2"]])

export default __exports__